import { ALLOWED_COLORS, ALLOWED_FONTS, SlideObject } from '../types';

function firstMatchingSlot(objects: SlideObject[], selectedId: string, slotId?: string): SlideObject | undefined {
  if (slotId) return objects.find((object) => object.slotId === slotId && object.id !== selectedId);
  const selected = objects.find((object) => object.id === selectedId);
  if (selected?.type === 'product') {
    return objects.find((object) => object.slotId === 'product' && object.id !== selectedId)
      || objects.find((object) => Boolean(object.slotId) && object.id !== selectedId);
  }
  return objects.find((object) => Boolean(object.slotId) && object.id !== selectedId);
}

export function canFitObjectInSlot(objects: SlideObject[], objectId: string, slotId?: string): boolean {
  const selected = objects.find((object) => object.id === objectId);
  const slot = firstMatchingSlot(objects, objectId, slotId);
  return Boolean(selected && slot && !selected.locks.position && !selected.locks.size);
}

export function fitObjectInSlot(objects: SlideObject[], objectId: string, slotId?: string): SlideObject[] {
  const selected = objects.find((object) => object.id === objectId);
  const slot = firstMatchingSlot(objects, objectId, slotId);
  if (!selected || !slot || selected.locks.position || selected.locks.size) return objects;
  return objects.map((object) => (
    object.id === objectId ? { ...object, x: slot.x, y: slot.y, w: slot.w, h: slot.h } : object
  ));
}

function styleNeedsAdapt(object: SlideObject, allowedColors: string[] = ALLOWED_COLORS): boolean {
  if (object.locks?.style) return false;
  const style = object.style || {};
  if (style.fontFamily && !(ALLOWED_FONTS as readonly string[]).includes(style.fontFamily)) return true;
  return (['color', 'backgroundColor', 'strokeColor'] as const).some((key) => {
    const value = style[key];
    return Boolean(value && value !== 'transparent' && !allowedColors.some((allowed) => allowed.toLowerCase() === value.toLowerCase()));
  });
}

export function wouldAdaptUnlockedStyles(objects: SlideObject[], allowedColors?: string[]): boolean {
  return objects.some((object) => styleNeedsAdapt(object, allowedColors));
}

export function adaptUnlockedStyles(objects: SlideObject[], allowedColors: string[] = ALLOWED_COLORS): SlideObject[] {
  return objects.map((object) => {
    if (!styleNeedsAdapt(object, allowedColors)) return object;
    let style = object.style ? { ...object.style } : {};
    if (style.fontFamily && !(ALLOWED_FONTS as readonly string[]).includes(style.fontFamily)) {
      style = { ...style, fontFamily: (style.fontSize || 0) >= 40 ? 'Kapra Neue' : 'Akkurat Std' };
    }
    for (const key of ['color', 'backgroundColor', 'strokeColor'] as const) {
      const value = style[key];
      if (value && value !== 'transparent' && !allowedColors.some((allowed) => allowed.toLowerCase() === value.toLowerCase())) {
        style = { ...style, [key]: key === 'backgroundColor' ? (allowedColors[3] || allowedColors[0]) : allowedColors[0] };
      }
    }
    return { ...object, style };
  });
}
